export default "__VITE_ASSET__BQqK3SJ2__"